<template>
  <nav class="position-relative d-lg-none" :aria-expanded="show_more">
    <transition name="slideBottomNav">
      <div
        v-show="show_more"
        class="bottom-nav-shadow has-bg-bottom-bar position-absolute w-100 translateY-100 z-index-1080"
        :class="{'active': show_more}">
        <a class="d-flex align-items-center p-3" href="/posts">
          <span class="sr-only">Posts</span>
          <div class="app-logo app-logo__img app-logo__img--light"></div>
        </a>

        <ul class="list-unstyled options-list__wrapper mb-1">
          <li class="options-list__list-item options-list__list-item--alt d-flex align-items-center justify-content-between border-bottom">
            <a
              href="/account/edit"
              class="d-flex align-items-center w-100 options-list__clickable pl-4"
              :class="{active: active_item == 'account'}"
            >
              <div class="avatar__wrapper avatar__wrapper--medium" v-if="current_user_name">
                <a class="avatar__link"  :style="{backgroundColor: current_user_fallback}">
                  {{ current_user_name[0] }}

                  <img
                    v-if="current_user_avatar_url"
                    class="avatar__img"
                    :src="current_user_avatar_url"
                  >
                </a>
              </div>

              Edit profile
            </a>
          </li>

          <li class="options-list__list-item options-list__list-item--alt d-flex align-items-center justify-content-between border-bottom">
            <a
              href="/groups"
              class="d-flex align-items-center w-100 options-list__clickable pl-4"
              :class="{active: active_item == 'groups'}"
            >
              Groups
            </a>
          </li>

          <li class="options-list__list-item options-list__list-item--alt d-flex align-items-center justify-content-between border-bottom">
            <a
              href="/invitation"
              class="d-flex align-items-center w-100 options-list__clickable pl-4"
              :class="{active: active_item == 'invitation'}"
            >
              Invite a friend
            </a>
          </li>

          <li class="options-list__list-item options-list__list-item--alt d-flex align-items-center justify-content-between border-bottom" v-if="current_user_is_admin === 'true'">
            <a
              href="/reported_items"
              class="d-flex align-items-center w-100 options-list__clickable pl-4"
              :class="{active: active_item == 'report_flags'}"
            >
              Reported Items
            </a>
          </li>

          <li class="options-list__list-item options-list__list-item--alt d-flex align-items-center justify-content-between border-bottom" v-if="current_user_is_admin === 'true'">
            <a
              href="/user_requests"
              class="d-flex align-items-center w-100 options-list__clickable pl-4"
              :class="{active: active_item == 'report_flags'}"
            >
              Users
            </a>
          </li>

          <li class="options-list__list-item options-list__list-item--alt d-flex align-items-center justify-content-between border-bottom">
            <a
              rel="nofollow"
              href="/users/sign_out"
              data-method="delete"
              class="d-flex align-items-center w-100 options-list__clickable pl-4"
            >
              <i class="mr-1 fas fa-sign-out-alt flex-0-0-25px text-center"></i>
              Log Out
            </a>
          </li>
        </ul>
      </div>
    </transition>

    <ul class="min-height-header-height list-unstyled d-flex justify-content-between align-items-center mb-0 h-100 position-relative has-bg-bottom-bar z-index-1081">
      <li class="text-center flex-fifth">
        <a href="/posts" class="bottom-nav-item d-block py-2" :class="{active: active_item == 'posts'}">
          <i class="fas fa-home"></i>
          <span class="d-block is-size-9">Posts</span>
        </a>
      </li>
      <li class="text-center flex-fifth">
        <a href="/events" class="bottom-nav-item d-block py-2" :class="{active: active_item == 'events'}">
          <i class="fas fa-calendar"></i>
          <span class="d-block is-size-9">Events</span>
        </a>
      </li>
      <li class="text-center flex-fifth">
        <a href="/surveys" class="bottom-nav-item d-block py-2" :class="{active: active_item == 'surveys'}">
          <i class="fas fa-chart-bar"></i>
          <span class="d-block is-size-9 this-thing">Surveys</span>
        </a>
      </li>
      <li class="text-center flex-fifth">
        <a href="/conversations" class="bottom-nav-item d-block py-2" :class="{active: active_item == 'conversations'}">
          <i class="fas fa-comment"></i>
          <span class="d-block is-size-9">Messaging</span>
        </a>
      </li>
      <li class="text-center flex-fifth">
        <button
          type="button"
          @click="toggleNav()"
          class="bottom-nav-item min-height-header-height d-block has-bg-bottom-bar w-100"
          :class="{active: show_more}"
        >
          <transition name="fadeNotificationsIcon" mode="out-in">
            <i
              class="fas"
              :class="[show_more ? 'fa-times' : 'fa-ellipsis-h']"
              :key="show_more ? 'close' : 'open'"
            ></i>
          </transition>

          <span class="d-block is-size-9 this-thing">{{ show_more ? 'Less' : 'More'}}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
  import axios from 'axios';

  axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content');

  export default {
    props: {
      current_user_is_admin: {
        type: null,
        required: true
      },
      active_item: String,
      current_user_name: String,
      current_user_fallback: String,
      current_user_avatar_url: String,
    },
    data () {
      return {
        show_more: false
      }
    },
    methods: {
      toggleNav() {
        this.show_more = !this.show_more;

        const SCROLLABLE_CONTENT = document.getElementById('js-scrollable-content');
        const OVERFLOW_HIDDEN_CLASS = "overflow-hidden";

        return this.show_more ? SCROLLABLE_CONTENT.classList.add(OVERFLOW_HIDDEN_CLASS) : SCROLLABLE_CONTENT.classList.remove(OVERFLOW_HIDDEN_CLASS);
      }
    },
  }
</script>

<style scoped lang="scss">
  .nav-open {
    overflow: hidden !important;
  }

  .bottom-nav-shadow {
    box-shadow: 0px -5px 15px 0px rgba(0, 0, 0, .3);
    z-index: 1080;
  }

  .bottom-nav-item {
    background-color: #858AA1;

    &.active {
      background-color: #a2a6b7;
    }
  }

  .slideBottomNav {
    &-enter-active,
    &-leave-active {
      transform: translateY(-100%);
    }

    &-enter-active {
      transition: transform 150ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
    }

    &-leave-active {
      transition: transform 300ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
    }

    &-enter,
    &-leave-to {
      transform: translateY(80px);
    }
  }
</style>
